module.exports = __webpack_public_path__ + "img/athletics_icon_6.163975e9.png";